import styled from 'common/styled-components';
import { Paper } from '@material-ui/core';

export const Container = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
`;

export const ReportList = styled(Paper)`
    flex: 2;
    height: 100%;
    overflow: auto;
    max-width: 300px;
    border-right: 2px solid ${props => props.theme.reports};
`;

export const ReportListHeader = styled.div`
    margin: 6px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ReportListCollapsed = styled(Paper)`
    height: 100%;
    border-right: 1px solid ${props => props.theme.reports};
    padding: 4px;
`;

export const SupersetView = styled.div`
    flex: 7;
    overflow: auto;
    height: 100%;
`;

export const SuperSetBox = styled.div`
    height: 100%;
    width: 100%;
    & iframe {
        height: 99%;
        width: 100%;
        border: 0;
    }
`;
